import { Injectable } from '@angular/core';
import { NgForage } from 'ngforage';
import { Observable, Subject } from 'rxjs';
import semaphore from 'semaphore';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import SemaphoreHelper from 'src/app/helpers/semaphore-helper';

@Injectable({
  providedIn: 'root'
})
export class ImmoIPImmoTaskSubmitInProgressService {
  private readonly storageKey = 'immo-ip-immo-task-submit-in-progress';
  private readonly submitInProgressSemaphore = semaphore(1);
  private readonly submitInProgressChanged = new Subject<never>();

  constructor(private ngForage: NgForage) {}

  public async getSubmitInProgress(): Promise<
    ImmoIPImmoTaskSubmitInProgressEntry[]
  > {
    let toReturn: ImmoIPImmoTaskSubmitInProgressEntry[] = null;
    await SemaphoreHelper.use(this.submitInProgressSemaphore, async () => {
      toReturn = await this.ngForage.getItem(this.storageKey);
    });
    return toReturn;
  }

  public async isInProgress(immoTaskId: number): Promise<boolean> {
    let toReturn = null;
    await SemaphoreHelper.use(this.submitInProgressSemaphore, async () => {
      const inProgress: ImmoIPImmoTaskSubmitInProgressEntry[] = await this.ngForage.getItem(
        this.storageKey
      );
      toReturn =
        CollectionHelper.isPopulated(inProgress) &&
        inProgress.some(p => p.immoTaskId === immoTaskId);
    });
    return toReturn;
  }

  public setSubmitInProgress(immoTaskId: number): Promise<void> {
    return SemaphoreHelper.use(this.submitInProgressSemaphore, async () => {
      let inProgress: ImmoIPImmoTaskSubmitInProgressEntry[] = await this.ngForage.getItem(
        this.storageKey
      );
      inProgress = inProgress != null ? inProgress : [];
      inProgress.push({ immoTaskId: immoTaskId });
      await this.ngForage.setItem(this.storageKey, inProgress);
      this.submitInProgressChanged.next();
    });
  }

  public removeSubmitInProgress(immoTaskId: number): Promise<void> {
    return SemaphoreHelper.use(this.submitInProgressSemaphore, async () => {
      const inProgress: ImmoIPImmoTaskSubmitInProgressEntry[] = await this.ngForage.getItem(
        this.storageKey
      );
      if (inProgress != null) {
        CollectionHelper.filterInPlace(
          inProgress,
          p => p.immoTaskId !== immoTaskId
        );
        await this.ngForage.setItem(this.storageKey, inProgress);
      }
      this.submitInProgressChanged.next();
    });
  }

  public getSubmitInProgressChangedSubscribable(): Observable<never> {
    return this.submitInProgressChanged;
  }
}

export interface ImmoIPImmoTaskSubmitInProgressEntry {
  immoTaskId: number;
}
